import { rem } from "polished";
import styled, { css } from "styled-components";

const StyledButton = styled.button<{ $active: boolean }>`
  height: ${rem(36)};
  width: calc(100% - 1px);
  border: 1px solid transparent;
  outline: none;
  background: var(--color-blue-100);
  cursor: pointer;
  &:hover {
    background: var(--color-blue-200);
  }
  &:focus[data-focus-visible-added] {
    border-color: var(--color-blue-500);
  }

  ${(props) =>
    props.$active &&
    css`
      border-color: var(--color-blue-500);
    `}
`;

const ListWrapper = styled.ul`
  --edge-radius: ${rem(4)};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${rem(2)};

  li:first-of-type {
    ${StyledButton} {
      border-top-left-radius: var(--edge-radius);
    }
  }
  li:nth-of-type(3) {
    ${StyledButton} {
      border-top-right-radius: var(--edge-radius);
    }
  }
  li:nth-of-type(7) {
    ${StyledButton} {
      border-bottom-left-radius: var(--edge-radius);
    }
  }
  li:nth-of-type(9) {
    ${StyledButton} {
      border-bottom-right-radius: var(--edge-radius);
    }
  }
`;
export { ListWrapper, StyledButton };
